import { useCallback } from "react";
import { useHubSpotAdapterAxiosInstance } from "./useHubSpotAdapterAxiosInstance.ts";

export type HubSpotSalesGroupDTO = {
  id: string;
  name: string;
  members: { id: string; email: string }[];
};

export function useGetHubSpotSalesGroups() {
  const axiosInstance = useHubSpotAdapterAxiosInstance();

  const getHubSpotSalesGroups = useCallback(async () => {
    const { data } = await axiosInstance.get<HubSpotSalesGroupDTO[]>(
      `/closer-availability/groups`,
    );
    return data;
  }, [axiosInstance]);

  return { getHubSpotSalesGroups };
}
